import { CATEGORY_DROPDOWN, CREATE_PRODUCT, DELETE_PRODUCT, EDIT_PRODUCT, LIST_PRODUCT, UPLOAD_PRODUCT_IMAGE, VIEW_PRODUCT } from "./types";


export const createProductAction = (data, onSuccess, onError) => {
    return {
        type: CREATE_PRODUCT,
        data,
        onSuccess,
        onError,
    };
};

export const editProductAction = (data, onSuccess, onError) => {
    return {
        type: EDIT_PRODUCT,
        data,
        onSuccess,
        onError,
    };
};

export const listProductAction = (data, onSuccess, onError) => {
    return {
        type: LIST_PRODUCT,
        data,
        onSuccess,
        onError,
    };
};

export const viewProductAction = (data, onSuccess, onError) => {
    return {
        type: VIEW_PRODUCT,
        data,
        onSuccess,
        onError,
    };
};

export const deleteProductAction = (data, onSuccess, onError) => {
    return {
        type: DELETE_PRODUCT,
        data,
        onSuccess,
        onError,
    };
};

export const uploadProductImageAction = (file, onSuccess, onError) => {
    return {
        type: UPLOAD_PRODUCT_IMAGE,
        file,
        onSuccess,
        onError,
    };
};

export const categoryDropDownAction = (data, onSuccess, onError) => {
    return {
        type: CATEGORY_DROPDOWN,
        data,
        onSuccess,
        onError,
    };
};